import {Component, OnInit} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {isEmpty, routePath} from 'sdv-common';
import {AlarmTypeService} from '../service/alarm-type.service';
import {AlarmService} from '../service/alarm.service';
import {ApiService} from '../service/api.service';
import {keys, redirect} from '../shared/constants';
import {AlarmLevelService} from '../service/alarm-level.service';
import {LanguageService} from '../service/language.service';
import {AlarmAttributeTypeService} from '../service/alarm-attribute-type.service';

@Component({
  selector: 'app-alarm',
  templateUrl: './alarm.component.html',
  styleUrls: ['./alarm.component.scss']
})
export class AlarmComponent implements OnInit {

  limit = 10;
  offset = 0;

  langId = 1;
  levelId = 2;
  alarmAttrTypeId = 1;

  alarm = {
    id: '',
    code: '',
    type: 2,
    attrs: [],
    locales: [],
    error: ''
  };

  error = '';
  loading = false;

  constructor(private apiService: ApiService,
              public alarmService: AlarmService,
              public alarmTypeService: AlarmTypeService,
              public alarmLevelService: AlarmLevelService,
              public alarmAttributeTypeService: AlarmAttributeTypeService,
              public languageService: LanguageService,
              private cookieService: CookieService) {
    const projectId = this.cookieService.get(keys.project);
    if (this.apiService.isAnonymous()) {
      redirect(routePath.login);
    } else if (isEmpty(projectId)) {
      redirect('/projects');
    } else {
      this.apiService.setParams({
        $project: projectId
      });
    }
  }

  ngOnInit() {
    this.renderer();
  }

  editAlarm(id: string) {
  }

  removeAlarm(id: string) {
  }

  renderer() {
    if (!this.alarm.locales[this.levelId + ':' + this.langId]) {
      this.alarm.locales[this.levelId + ':' + this.langId] = {
        languageId: this.langId,
        levelId: this.levelId,
        title: '',
        text: ''
      };
    }
  }

  addAttr() {
    const type = this.alarmAttributeTypeService.get(this.alarmAttrTypeId);
    let count = 0;
    for (const attr of this.alarm.attrs) {
      if (attr.type === type.id) {
        count++;
      }
    }
    if (count >= type.quantity) {
      return;
    }
    this.alarm.attrs.push({
      type: type.id,
      value: ''
    });
  }
}
